import React from "react";
import ReactDOM from "react-dom";
// import Handlebars from "handlebars";
const { data } = require('./Clients.data');

import "./Clients.scss";

// const htmlContent = require("./Clients.html");
import htmlContent from './Clients.hbs';// works as template fn

// const template = Handlebars.compile(htmlContent);// fails

const Clients = (props) => {

  const {
    // data
  } = props;

  const h_cont = htmlContent(data);

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: h_cont }} className={`hbs_comp plax-bg`} />
      {/* <div dangerouslySetInnerHTML={{ __html: template(data) }} /> */}
    </>
  );
}

export default Clients
